import { Outlet, Navigate } from "react-router-dom";

interface PublicRouteProps {
  isLoggedIn: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ isLoggedIn }) => {
  // If logged in, redirect to feed page
  if (isLoggedIn) {
    return <Navigate to="/feed" />;
  }

  // If not logged in, allow access to public pages
  return <Outlet />;
};

export default PublicRoute;